<template>
  <div class="control-box">
    <div>
      <el-upload
        ref="upload"
        v-loading="loading"
        :action="action"
        :headers="headers"
        :multiple="false"
        name="file"
        :limit="1000"
        :before-upload="onBefore"
        :on-success="onSuccess"
        :on-error="onError"
        :show-file-list="false"
        list-type="picture-card"
        class="uploader"
        :disabled="!!imageUrl"
      >
        <div v-if="imageUrl" class="uploader-image" @click="onClick">
          <el-image :src="imageUrlFull" style="height: 100%; width: auto">
            <template slot="error">
              <div class="el-image__error" style="padding: 0 20px">Ошибка</div>
            </template>
          </el-image>
          <div class="uploader-image__button">
            <el-button type="danger" icon="el-icon-delete" circle />
          </div>
        </div>
        <el-button v-else class="uploader-button" size="mini" type="primary"
          >Загрузить</el-button
        >
      </el-upload>
    </div>
    <div v-if="sizeSetted" class="size-box">
      <el-card class="box-card">
        Рекомендуемый размер изображения {{ recWidth }}*{{ recHeight }}.
      </el-card>
    </div>
  </div>
</template>

<script>
import defaultSettings from "@/settings";
import { getToken } from "@/utils/auth";

const { baseApi } = defaultSettings;

export default {
  props: {
    value: {
      type: [String, Object],
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "other",
    },
    /**
     * Добавляем хеш к изображению
     */
    timestamp: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Рекомендуемый размер изображения
     */
    recWidth: {
      type: Number,
      required: false,
      default: null,
    },
    recHeight: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      imgStatusError: false,
      loading: false,
    };
  },
  computed: {
    action() {
      return `${baseApi}/api/admin/files/`;
    },
    headers() {
      return {
        Authorization: `Bearer ${getToken()}`,
      };
    },
    imageUrlFull() {
      return typeof this.imageUrl === "string"
        ? `${baseApi}${this.imageUrl}`
        : `${baseApi}${this.imageUrl.url}`;
    },
    sizeSetted() {
      return this.recWidth && this.recHeight;
    },
    imageUrl: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onBefore() {
      this.loading = true;
    },
    onError() {
      this.loading = false;
      this.$emit("input", null);
      this.$message({
        type: "error",
        message: "Ошибка при загрузке.",
      });
    },
    onSuccess(res) {
      this.loading = false;
      this.$emit("input", res.url);
    },
    onClick() {
      this.$refs.upload.clearFiles();
      setTimeout(() => this.$emit("input", null), 0);
    },
  },
};
</script>

<style>
.uploader-image img {
  width: auto !important;
}
</style>
<style scoped>
.control-box {
  display: flex;
  flex-direction: row;
}
.size-box {
  height: 100%;
}
.uploader {
  display: inline-block;
}
.uploader-image {
  height: 100%;
  position: relative;
  min-width: 50px;
}
.uploader-image img {
  height: 100%;
  width: auto;
}
.uploader-image:hover .uploader-image__button {
  opacity: 1;
}
.uploader-image__button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  opacity: 0;
  transition: 0.2s;
}
.uploader-image__button {
  pointer-events: none;
}
.uploader-image__button button {
  opacity: 0.8;
}
.uploader-button {
  margin-left: 20px;
  margin-right: 20px;
}
</style>

<style>
.uploader .el-upload--picture-card {
  width: auto;
  height: 90px;
  line-height: 88px;
}
.uploader .el-upload--picture-card i {
  font-size: 14px;
  color: #fff;
}
</style>
